(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["lunar-home-video-control"] && !Shopify.designMode) return;
  try {
    class LunarHomeVideoControl extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.video = this.closest('.lunar-home-hero-video')?.querySelector('video');
      this.button = this.querySelector('button');
      if (!this.video || !this.button) {
        this.hidden = true;
        return;
      }
      this.visible = true;
      this.manuallyPaused = false;
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.button.addEventListener('click', this.toggle, { signal });
      this.video.addEventListener('play', this.handlePlay, { signal });
      this.video.addEventListener('pause', this.sync, { signal });
      document.addEventListener('visibilitychange', this.updatePlayback, { signal });
      this.motion.addEventListener('change', this.updatePlayback, { signal });
      this.observer?.disconnect();
      this.observer = new IntersectionObserver(([entry]) => {
        this.visible = entry.isIntersecting;
        this.updatePlayback();
      });
      this.observer.observe(this.closest('.lunar-home-hero-video'));
      this.updatePlayback();
      this.sync();
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
    }

    toggle = () => {
      this.manuallyPaused = !this.video.paused;
      this.updatePlayback();
    };

    handlePlay = () => {
      if (this.motion.matches || !this.visible || document.hidden || this.manuallyPaused) this.video.pause();
      this.sync();
    };

    updatePlayback = () => {
      if (this.motion.matches || !this.visible || document.hidden || this.manuallyPaused) {
        this.video.pause();
      } else {
        this.video.play().catch(() => {});
      }
      this.sync();
    };

    sync = () => {
      this.toggleAttribute('data-paused', this.video.paused);
      this.button.setAttribute('aria-label', this.video.paused ? this.dataset.playLabel : this.dataset.pauseLabel);
    };
  }
  if (!customElements.get('lunar-home-video-control')) customElements.define('lunar-home-video-control', LunarHomeVideoControl);
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["trustpilot-service-mini"] && !Shopify.designMode) return;
  try {
    class LunarTrustpilotRating extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.loadingTimeout);
      this.controller = new AbortController();
      const widget = this.querySelector('.trustpilot-widget');
      if (!widget) return;
      const { signal } = this.controller;
      const ready = () => {
        this.classList.remove('is-loading');
        clearTimeout(this.loadingTimeout);
        this.observer?.disconnect();
      };
      if (this.dataset.loadingPlaceholder === 'true' && !widget.querySelector('iframe')) {
        this.classList.add('is-loading');
        const watchFrame = () => {
          const frame = widget.querySelector('iframe');
          if (frame && frame !== this.watchedFrame) {
            this.watchedFrame = frame;
            frame.addEventListener('load', ready, { once: true, signal });
          }
        };
        this.observer = new MutationObserver(watchFrame);
        this.observer.observe(widget, { childList: true, subtree: true });
        this.loadingTimeout = setTimeout(ready, 6000);
      } else ready();
      const load = () => {
        if (this.isConnected && this.initializedWidget !== widget && !widget.querySelector('iframe') && window.Trustpilot?.loadFromElement) {
          this.initializedWidget = widget;
          window.Trustpilot.loadFromElement(widget, true);
        }
      };
      load();
      document.querySelector('script[src*="widget.trustpilot.com/bootstrap/"]')?.addEventListener('load', load, { once: true, signal });
    }

    disconnectedCallback() {
      this.controller?.abort();
      this.observer?.disconnect();
      clearTimeout(this.loadingTimeout);
    }
  }
  if (!customElements.get('lunar-trustpilot-rating')) customElements.define('lunar-trustpilot-rating', LunarTrustpilotRating);
  } catch(e) { console.error(e); }
})();

})();
